import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, Text } from '@chakra-ui/react';

const convertBreadCrumbNameFromPath = (key: string) => ({
  configuracao: 'Configuração',
  publicacao: 'Publicação',
  publicacoes: 'Gerenciar publicações',
  'gerenciar-perfil-usuario': 'Gerenciar Perfi de Usuário',
  'editar-perfil-usuario': 'Editar Perfil de Usuário',
  create: 'Incluir novo Usuário',
  'gerenciar-paginas': 'Gerenciar Páginas',
  acoes: 'Ações',
  'adicionar-pagina': 'Incluir Nova Página',
  'midias-sociais': 'Configurações de integrações de redes sociais',
  'gerenciar-rede-social': 'Redes Sociais',
  'editar-rede-social': 'Editar Publicação',
  noticia: 'Gerenciar Notícias',
  'servico-comunicacao': 'Serviço de Comunicação',
  'gerenciar-categoria': 'Gerenciar Categorias',
  'inserir-noticia': 'Criar Notícia',
  'editar-noticia': 'Editar Notícia',
  category: 'Gerenciar Categorias',
  'criar-categoria': 'Incluir Categoria',
  'editar-categoria': 'Editar Categoria',
  aplicativo: 'Gerenciar Aplicativos',
  'novo-aplicativo': 'Incluir Aplicativo',
  'editar-aplicativo': 'Editar Aplicativo',
  banner: 'Gerenciar Banners',
  'novo-banner': 'Criar Banner',
  'editar-banner': 'Editar Banner',
  'gerenciar-menu': 'Gerenciar menu',
  'inicio': 'Página Inicial',
  'gerenciar-usuario': 'Gerenciar Usuário',
  'adicionar-usuario': 'Adicionar Usuário',
  'editar-usuario': 'Editar Usuário',
  'visualizacao-necessidade-atuacao': 'Avisos de necessidade de atuação',
  'edicao-cidade-inteligente': 'Edição Cidade Inteligente',
  'redes-sociais': 'Redes Sociais',
  'incluir-rede-social': 'Inserir Publicação',
  'configurar-rede-social': 'Configurar rede social',
  'editar-cabecalho': 'Edição de cabeçalho',
  'faixa-navegacao-principal': 'Gerenciar Faixa de Navegação Principal',
  'rodape': 'Gerenciar Rodapé',
  'aprovar-publicacao-rede-social': 'Aprovar publicação',
  'aprovar-noticia': 'Aprovar notícia',
  'aprovar-banner': 'Aprovar banner',
  'aprovar-evento': 'Aprovar evento',
  'eventos': 'Gerenciar Eventos',
  'criar-evento': 'Criar Evento',
  'outras-paginas': 'Gerenciar Outras Páginas',
  'inserir-pagina': 'Incluir Página',
  'gerenciar-biblioteca': 'Biblioteca de Mídias Digitais',
  'inserir-midia': 'Nova Mídia Digital',
  'editar-midia': 'Editar Mídia Digital',
  'gerenciar-tipo-midia': 'Gerenciar Tipo de Mídia',
  'editar-tipo-midia': 'Editar Tipo de Mídia',
  'inserir-tipo-midia': 'Inserir Tipo de Mídia',
  'editar-pagina': 'Editar Página',
  'modelo-1': 'Modelo 1: Apresentação de Secretarias',
  'modelo-3': 'Modelo 3 - Texto Livre',
  'modelo-4': 'Modelo 4 - Mídia Livre',
  'modelo-5': 'Modelo 5 - Linha do Tempo',
  'editar-pagina-modelo-1': 'Editar Modelo 1: Apresentação de Secretarias',
  'editar-pagina-modelo-3': 'Editar Modelo 3 - Texto Livre',
  'editar-pagina-modelo-4': 'Editar Modelo 4 - Mídia Livre',
  'editar-pagina-modelo-5': 'Editar Modelo 5 - Linha do Tempo',
  'evento': 'Eventos',
  'aviso-publicacoes-rejeitadas': 'Avisos de publicações rejeitadas',
  'relatorios': 'Relatórios',
  'relatorio-rede-social': 'Relatório de Desempenho das Publicações',
  'gerenciar-secretarias': 'Gerenciar Secretarias',
  'adicionar-secretaria': 'Adicionar Secretaria',
  'editar-secretaria': 'Editar Secretaria',
  'imprensa-oficial': 'Imprensa Oficial',
  'inserir-imprensa-oficial': 'Nova Publicação',
  'editar-imprensa-oficial': 'Editar Imprensa Oficial',
  'aprovar-imprensa-oficial': 'Aprovar Imprensa Oficial',
}[key]);

const SettingsBreadcrumb = () => {
  const { pathname } = useLocation();
  const paths = pathname.split('/').filter(Boolean);

  return (
    <Breadcrumb spacing="8px" separator=">" color="#2883de">
      {paths.slice(1).map((p, index) => {
        const pageName = convertBreadCrumbNameFromPath(p);
        if (!pageName) return null;

        const separator = index !== paths.length - 2 ? '>' : undefined;

        let toLink: string | { pathname: string, state: object } = `/${paths.slice(0, index + 2).join('/')}`;

        if (p === 'editar-rede-social' && paths[index + 2]) {
          const id = paths[index + 2];
          toLink = {
            pathname: `/${paths.slice(0, index + 3).join('/')}`,
            state: { descricaoRede: 'redeSocial', codigoRede: '1' },
          };
        }

        if (
          p === 'editar-usuario' || 
          p == 'editar-perfil-usuario' || 
          p == 'editar-aplicativo' || 
          p == 'editar-categoria' || 
          p == 'editar-midia' || 
          p == 'aprovar-banner' || 
          p == 'aprovar-noticia' || 
          p == 'aprovar-evento' || 
          p == 'editar-pagina' || 
          p == 'editar-pagina-modelo-1' || 
          p == 'editar-pagina-modelo-3' || 
          p == 'editar-pagina-modelo-4' || 
          p == 'editar-pagina-modelo-5' || 
          p == 'aprovar-publicacao-rede-social' || 
          p == 'editar-imprensa-oficial' ||
          p == 'aprovar-imprensa-oficial' ||
          p === 'info') {
          return (
            <BreadcrumbItem key={index + 1} separator={separator}>
              <Text 
                color= {'#2883de'}
                cursor={'pointer'}
                _hover={{
                    color: 'blue.500',
                  }}
                  >
                  {pageName}
              </Text>
            </BreadcrumbItem>
          );
        }

        return (
          <BreadcrumbItem key={index + 1} separator={separator}>
            <Link to={toLink}>
              <Text 
                color= {'#2883de'}
                _hover={{
                    color: '#1468C9',
                  }}
                  >
                  {pageName}
              </Text>
            </Link>
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
};

export default SettingsBreadcrumb;
